import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Typography, Button } from 'antd';
import moment from 'moment';
import 'moment-duration-format';
import { getGCSUrl } from '../../../../../services/Common';
import { GreenRoundCheck, RoundedMinusIcon } from '../../../../components/common/CustomIcon';

const skillLeftMap = { 1: 'One', 2: 'Two', 3: 'Three', 4: 'Four', 5: 'Five', 6: 'Six', 7: 'Seven' };
const JobDetailSkills = ({ skills = [], onStartTest, hideTitle }) => {
  let skillLeft = 0;
  if (skills.length > 0) {
    skillLeft = skills.filter((skill) => (skill.linked_mcq_id && ((skill.status || '').toLowerCase() === 'not_taken' || (skill.status || '').toLowerCase() === 'inprogress'))).length;
  }
  return (
    <div className="job-detail-skill-wrapper">
      {skills.length > 0
        ? (
          <div>
            {
              hideTitle
                ? null
                : (
                  <Row>
                    <Col style={{ height: '26px' }}><Typography.Text className="job-detail-skill-title">Required skills</Typography.Text></Col>
                    {skillLeft > 0
                      ? (
                        <Col style={{ marginTop: '12px', height: '19px' }}><Typography.Text className="job-detail-skill-description">{`${skillLeftMap[skillLeft.toString()]} more ${skillLeft > 1 ? 'tests' : 'test'} to go!`}</Typography.Text></Col>
                      )
                      : null}
                  </Row>
                )
            }
            <Row type="flex" gutter={[16, 16]} style={{ marginTop: '25px' }}>
              {skills.map(skill => (
                <Col key={skill.id}>
                  <SkillCard
                    icon={skill.skill_icon_url}
                    skill_name={skill.skill_name}
                    status={skill.status}
                    linked_mcq_id={skill.linked_mcq_id}
                    duration={skill.skill_duration}
                    nJobs={skill.nJobs}
                    acc_challenge={skill.acc_challenge}
                    onStartTest={onStartTest}
                  />
                </Col>
              ))}
            </Row>
          </div>
        )
        : null}
    </div>
  );
};

const SkillCard = ({ icon, skill_name, status, nJobs, duration, linked_mcq_id, onStartTest, acc_challenge }) => {
  const auth = localStorage.getItem('authenticated');
  let showStart = false;
  if (auth && auth === 'true') showStart = true;
  let statusText = null;
  if (status) {
    if (status.toLowerCase() === 'passed') {
      statusText = <div><GreenRoundCheck /> <Typography.Text className="job-details-mcq-pass">Passed</Typography.Text></div>;
    } else if (status.toLowerCase() === 'failed') {
      statusText = <div><RoundedMinusIcon /> <Typography.Text className="job-details-mcq-not-pass">Failed</Typography.Text></div>;
    } else if (status.toLowerCase() === 'not_taken' && !linked_mcq_id) statusText = <Typography.Text className="job-details-mcq-not-pass">Test not available</Typography.Text>;
    else if (status.toLowerCase() === 'not_taken' && linked_mcq_id && linked_mcq_id !== '') {
      statusText = <Typography.Text className="job-detail-mcq-time">{moment.duration(duration, 'minutes').format('m [min]')}</Typography.Text>;
    }
  }
  return (
    <div className="job-details-skill-card">
      <div className="job-details-skill-card-img">{icon ? <img src={`${getGCSUrl()}/icon/${icon}`} className="job-details-skill-icon" /> : null}</div>
      <div className="job-details-skill-card-name">{skill_name}</div>
      <div>
        {statusText && !nJobs ? statusText : null}
        {nJobs || null}
      </div>
      <div>
        {
          showStart && status && status.toLowerCase() === 'not_taken' && linked_mcq_id && linked_mcq_id !== ''
            ? (
              <Col style={{ marginTop: '24px', marginLeft: '31px' }}><Button onClick={() => onStartTest(skill_name, linked_mcq_id, acc_challenge)} type="link" className="job-details-mcq-start">Start Quiz</Button></Col>
            )
            : null
        }
        {
          showStart && status && status.toLowerCase() === 'inprogress' && linked_mcq_id && linked_mcq_id !== ''
            ? (
              <Col style={{ marginTop: '24px', marginLeft: '15px' }}><Button onClick={() => onStartTest(skill_name, linked_mcq_id, acc_challenge)} type="link" className="job-details-mcq-start">Continue test</Button></Col>
            )
            : null
        }
      </div>
    </div>
  );
};

SkillCard.propTypes = {
  icon: PropTypes.string,
  skill_name: PropTypes.string,
  status: PropTypes.string,
  duration: PropTypes.number,
  linked_mcq_id: PropTypes.number,
  onStartTest: PropTypes.func,
  nJobs: PropTypes.any,
  acc_challenge: PropTypes.number
};

JobDetailSkills.propTypes = {
  skills: PropTypes.array.isRequired,
  onStartTest: PropTypes.func.isRequired,
  hideTitle: PropTypes.bool
};

export default JobDetailSkills;
